/**
 * useBrandLogos — fetches the super-admin-configured brand logo URLs once
 * and caches them in React Query. Every consumer of AnimatedBrandMark uses
 * this so uploading a new logo instantly propagates to every logo slot
 * across the app.
 */
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export type BrandLogoSlot = "app" | "shop" | "score";

export interface BrandLogos {
  app: string | null;
  shop: string | null;
  score: string | null;
}

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

async function fetchLogos(): Promise<BrandLogos> {
  const { data } = await axios.get(`${BACKEND}/api/brand/logos`);
  return {
    app: data?.app ?? null,
    shop: data?.shop ?? null,
    score: data?.score ?? null,
  };
}

export function useBrandLogos() {
  return useQuery<BrandLogos>({
    queryKey: ["brand-logos"],
    queryFn: fetchLogos,
    staleTime: 60_000,
  });
}

export function pickLogo(
  logos: BrandLogos | undefined,
  slot: BrandLogoSlot,
  fallback = "/brand/socibaba-icon.png"
): string {
  if (!logos) return fallback;
  return logos[slot] || fallback;
}
